import { useState } from "react";

interface FeatureCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  screenshot?: string;
  screenshotAlt?: string;
}

export function FeatureCard({ icon, title, description, screenshot, screenshotAlt }: FeatureCardProps) {
  const [expanded, setExpanded] = useState(false);

  return (
    <>
      <div className="bg-dark-card border border-dark-border rounded-xl p-6 hover:border-warm-600 transition-colors duration-200 flex flex-col">
        <div className="w-12 h-12 rounded-lg bg-dark-hover flex items-center justify-center mb-4 text-warm-100">
          {icon}
        </div>
        <h3 className="text-lg font-semibold text-warm-50 mb-2">{title}</h3>
        <p className="text-warm-500 text-sm leading-relaxed mb-4">{description}</p>
        {screenshot && (
          <button
            type="button"
            onClick={() => setExpanded(true)}
            className="mt-auto block w-full cursor-pointer group"
          >
            <img
              src={screenshot}
              alt={screenshotAlt ?? title}
              className="w-full rounded-lg border border-dark-border shadow-lg group-hover:border-warm-600 transition-colors duration-200"
              loading="lazy"
            />
          </button>
        )}
      </div>

      {expanded && screenshot && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4 cursor-pointer"
          onClick={() => setExpanded(false)}
          onKeyDown={(e) => e.key === "Escape" && setExpanded(false)}
          role="button"
          tabIndex={0}
        >
          <img
            src={screenshot}
            alt={screenshotAlt ?? title}
            className="max-w-full max-h-[90vh] rounded-xl border border-dark-border shadow-2xl"
          />
        </div>
      )}
    </>
  );
}
